/// <reference types="jquery" />
import ko = require("knockout");
import Q = require("q");

import AdminSettings = require("Build/Scripts/Admin.Settings");
import AdminResourceLimits = require("Build/Scripts/Admin.ResourceLimits");
import BuildAdminControls = require("Build/Scripts/Controls.Admin");
import BuildResources = require("Build/Scripts/Resources/TFS.Resources.Build");

import BuildClient = require("Build.Common/Scripts/Api2.2/ClientServices");

import AgentAcquisitionDialog = require("DistributedTaskControls/Components/AgentAcquisitionDialog");

import TFS_Host_TfsContext = require("Presentation/Scripts/TFS/TFS.Host.TfsContext");
import TFS_Knockout = require("Presentation/Scripts/TFS/TFS.Knockout");
import { LicenseFeatureIds, FeatureAvailabilityFlags } from "Presentation/Scripts/TFS/Generated/TFS.Server.WebAccess.Constants";
import TFS_FeatureLicenseService = require("Presentation/Scripts/TFS/TFS.FeatureLicenseService");
import TFS_OM_Common_TypeOnly = require("Presentation/Scripts/TFS/TFS.OM.Common");

import BuildCommon = require("TFS/Build/Contracts");
import DistributedTask = require("TFS/DistributedTask/Contracts");
import DistributedTaskApi = require("TFS/DistributedTask/TaskAgentRestClient");

import VSS_Platform_TypeOnly = require("VSS/Common/Contracts/Platform");
import Controls = require("VSS/Controls");
import Dialogs = require("VSS/Controls/Dialogs");
import Splitter = require("VSS/Controls/Splitter");
import { logError } from "VSS/Diag";
import Events_Action = require("VSS/Events/Action");
import Menus = require("VSS/Controls/Menus");
import Navigation = require("VSS/Controls/Navigation");
import { FeatureAvailabilityService } from "VSS/FeatureAvailability/Services";
import Navigation_Services = require("VSS/Navigation/Services");
import Security_RestClient_TypeOnly = require("VSS/Security/RestClient");
import Service = require("VSS/Service");
import Utils_Core = require("VSS/Utils/Core");
import Utils_String = require("VSS/Utils/String");
import VSS = require("VSS/VSS");
import VSS_WebApi_Constants_TypeOnly = require("VSS/WebApi/Constants");
import VSS_Resources_Platform = require("VSS/Resources/VSS.Resources.Platform");

const delegate = Utils_Core.delegate;
const TfsContext = TFS_Host_TfsContext.TfsContext;

export class AdminResourceLimitsTab extends Navigation.NavigationViewTab {
    public initialize() {
        super.initialize();

        this._tfsContext = TfsContext.getDefault();
        var tfsConnection: Service.VssConnection = new Service.VssConnection(this._tfsContext.contextData);
        var taskHubLicenseClient: DistributedTaskApi.TaskAgentHttpClient = tfsConnection.getHttpClient<DistributedTaskApi.TaskAgentHttpClient>(DistributedTaskApi.TaskAgentHttpClient);

        Q.all([this._hasOnPremManageUsersPermission(), taskHubLicenseClient.getTaskHubLicenseDetails("Release", true, true)]).spread(
            (canManageOnPremUsers: boolean, licenseDetails: DistributedTask.TaskHubLicenseDetails) => {
                this._licenseDetails = licenseDetails;
                this._canManageOnPremUsers = canManageOnPremUsers;
                this._initialize();
            },
            (error) => {
                if (!!error) {
                    Dialogs.show(AdminResourceLimits.OneButtonModalDialog, {
                        title: BuildResources.ErrorLabelText,
                        closeButtonText: BuildResources.CloseButtonText,
                        dialogClass: "r-get-license-error-dialog",
                        content: Utils_String.format("<div>{0}</div>", error.message || error)
                    });
                }
            });
    }

    /**
     * Called whenever navigation occurs with this tab as the selected tab
     * @param rawState The raw/unprocessed hash/url state parameters (string key/value pairs)
     * @param parsedState Resolved state objects parsed by the view
     */
    public onNavigate(rawState: any, parsedState: any) {
    }

    public dispose(): void {
        super.dispose();
    }

    private _initialize() {
        this._viewModel = new AdminResourceLimits.AdminResourceLimitsViewModel(this._tfsContext, this._licenseDetails, this._canManageOnPremUsers);
        if (!this._template) {
            this._template = TFS_Knockout.loadHtmlTemplate("br_admin_resourcelimits_tab").appendTo(this._element);
            ko.applyBindings(this._viewModel, this._template[0]);
        }
    }

    private _hasOnPremManageUsersPermission(): Q.Promise<boolean> {
        let hasManageOnPremUsers: boolean = false;
        let hasManagePromise: Q.Deferred<boolean> = Q.defer<boolean>();

        if (!this._tfsContext.isHosted) {
            VSS.using(["Presentation/Scripts/TFS/TFS.OM.Common", "VSS/Common/Contracts/Platform", "VSS/Security/RestClient", "VSS/WebApi/Constants"],
                (TFS_OM_Common: typeof TFS_OM_Common_TypeOnly,
                    VSS_Platform: typeof VSS_Platform_TypeOnly,
                    Security_RestClient: typeof Security_RestClient_TypeOnly,
                    VSS_WebApi_Constants: typeof VSS_WebApi_Constants_TypeOnly) => {

                    let frameworkNamespaceId = "1f4179b3-6bac-4d01-b421-71ea09171400";
                    let frameworkPermissionsGenericWrite = 2;
                    let frameworkNamespaceToken = "FrameworkGlobalSecurity";
                    let deploymentHostConnection = TFS_OM_Common.Deployment.getDefaultConnection();

                    deploymentHostConnection.beginGetServiceUrl(VSS_WebApi_Constants.ServiceInstanceTypes.TFS, VSS_Platform.ContextHostType.Deployment)
                        .then((rootUrl: string) => {

                            let securityClient = new Security_RestClient.SecurityHttpClient2(rootUrl);
                            let securityPromise = <Q.Promise<boolean>>securityClient.hasPermission(frameworkNamespaceId, frameworkPermissionsGenericWrite, frameworkNamespaceToken);

                            securityPromise.then((hasPermission: boolean) => {
                                hasManageOnPremUsers = hasPermission;
                            }).fin(() => {
                                hasManagePromise.resolve(hasManageOnPremUsers);
                            });
                        },
                        (error) => {
                            hasManagePromise.resolve(hasManageOnPremUsers);
                        });
                },
                (error) => {
                    hasManagePromise.resolve(hasManageOnPremUsers);
                });
        }
        else {
            hasManagePromise.resolve(hasManageOnPremUsers);
        }

        return hasManagePromise.promise;
    }

    private _tfsContext: TFS_Host_TfsContext.TfsContext;
    private _template: JQuery = null;
    private _viewModel: AdminResourceLimits.AdminResourceLimitsViewModel;
    private _licenseDetails: DistributedTask.TaskHubLicenseDetails;
    private _canManageOnPremUsers: boolean;
}

export class BuildAdminView extends Navigation.TabbedNavigationView {
    private _tfsContext: TFS_Host_TfsContext.TfsContext;

    public initializeOptions(options?: any) {
        var tabs = {};
            
        this._tfsContext = options.tfsContext || TfsContext.getDefault();

        if (FeatureAvailabilityService.isFeatureEnabled(FeatureAvailabilityFlags.BuildAndReleaseResourceLimits, false)) {
            tabs[BuildAdminControls.BuildAdminActionIds.ResourceLimits] = AdminResourceLimitsTab;
        }

        super.initializeOptions($.extend({
            tabs: tabs,
            hubContentSelector: ".buildvnext-admin-content",
            pivotTabsSelector: ".buildvnext-admin-tabs"
        }, options));
    }

    public parseStateInfo(action: string, rawState: any, callback: IResultCallback) {
        var state: any = {};

        this.setState(state);

        action = action || BuildAdminControls.BuildAdminActionIds.Settings;

        callback(action, state);
    }
}
VSS.classExtend(BuildAdminView, TfsContext.ControlExtensions);

Controls.Enhancement.registerEnhancement(BuildAdminView, ".buildvnext-admin-view");

// TFS plugin model requires this call for each tfs module.
VSS.tfsModuleLoaded("AdminView", exports);